'use client';

import React, { ForwardedRef, forwardRef } from 'react';

import { cn } from '@/app/_helper/tailwind';

import { useAgent } from '../../_provider/AgentProvider';

const NAME_CARD_BACK = `${process.env.NEXT_PUBLIC_BASE_URL || 'https://rumah123portal.staging.99iddev.net'}/asset-core/images/agent/name-card-back.png`;

const CardBack = forwardRef(
    (
        { className }: { className?: string },
        forwardedRef: ForwardedRef<any>,
    ) => {
        const { organizationName, companyPicture, agentType } = useAgent();

        return (
            <div
                ref={forwardedRef}
                className={cn(
                    'relative overflow-hidden max-w-[900px] w-[900px] aspect-[900/500] bg-[#F3F3F3]',
                    className,
                )}
            >
                {
                    // TEMUKAN RUMAH123
                }
                <div className='absolute z-[2] bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2'>
                    <div className='text-3xs font-bold text-accent'>
                        Powered by
                    </div>
                    <img
                        className='w-[87px] aspect-[87/18]'
                        src={`${process.env.NEXT_PUBLIC_BASE_URL || 'https://rumah123portal.staging.99iddev.net'}/asset-core/images/assets/logo_rumah123_blue.png`}
                        alt='Logo Rumah123.com'
                        draggable='false'
                        decoding='async'
                    />
                </div>
                {
                    // AGENCY LOGO
                }
                {agentType && agentType === 'Agen Korporat' && (
                    <div className='absolute z-[2] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 flex justify-center items-center w-[333px] h-[118px] rounded-md shadow-md bg-white'>
                        <img
                            src={companyPicture}
                            alt={organizationName}
                            decoding='async'
                            className='h-full object-contain'
                        />
                    </div>
                )}
                <img
                    src={NAME_CARD_BACK}
                    alt='kartu nama belakang'
                    className='absolute top-0 left-0 right-0 bottom-0 w-full h-full object-cover object-center'
                />
            </div>
        );
    },
);

export default CardBack;
